import type { TOC } from '@ember/component/template-only';

interface PageSectionSignature {
  Element: HTMLElement;
  Blocks: {
    default: [];
  };
}
export default <template>
  <section class="ui__page__section" ...attributes>
    {{yield}}
  </section>
</template> satisfies TOC<PageSectionSignature>;
